import React from 'react';
import { Typography } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ApiDetailTab } from '../../../types/app';
import { ErrorDisplay, BackButton } from '../../common';
import { ArticleContent } from '../../../types/api-definitions';
import {
  StyledArticleContainer,
  StyledHeaderContainer,
  StyledErrorContainer,
  StyledArticleContentBox,
  markdownContentSx,
  articleTitleSx,
} from './ArticleViewer.styles';
import MarkdownRenderer from './MarkdownRenderer';

interface ArticleViewerProps {
  article: ArticleContent;
}

const ArticleViewer: React.FC<ArticleViewerProps> = ({ article }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { slug: apiSlug } = useParams<{ slug: string }>();

  const handleBack = () => {
    navigate(`/api-definitions/${apiSlug}?tab=${ApiDetailTab.GUIDES}`);
  };

  if (!apiSlug) {
    return <ErrorDisplay error={t('apiDetail.specsTab.apiIdRequired')} severity='error' />;
  }

  if (!article) {
    return (
      <StyledErrorContainer>
        <ErrorDisplay error={t('apiDetail.guidesTab.noArticles')} severity='info' />
      </StyledErrorContainer>
    );
  }

  return (
    <StyledArticleContainer>
      <StyledHeaderContainer>
        <BackButton onClick={handleBack} aria-label={t('common.backToArticles')} />
        <Typography variant='h1' component='h1' sx={articleTitleSx}>
          {article.title}
        </Typography>
      </StyledHeaderContainer>
      <StyledArticleContentBox sx={markdownContentSx}>
        <MarkdownRenderer content={article.content} />
      </StyledArticleContentBox>
    </StyledArticleContainer>
  );
};

export default ArticleViewer;
